import { z } from "zod";

const BrowseActivitiesSummarySchema = z.object({
  query: z.any(),
});

export default BrowseActivitiesSummarySchema;
